import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRICE_LABEL, PRIMARY_CTA } from '../data/offer';
import { everythingIncluded } from '../data/everythingIncluded';
import { trackCheckout } from '../utils/tracking';
export function EverythingIncluded() {
  const featured = everythingIncluded.filter(item => item.featured);
  const supporting = everythingIncluded.filter(item => !item.featured);
  return <section className="py-24 px-4 bg-[#F3F7FA]" data-id="element-82" data-mp="3djueifd6yagl">
      <div className="max-w-5xl mx-auto" data-id="element-83" data-mp="3dkm9pp2vm66c">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-[#0B2545] text-center mb-12 uppercase" data-id="element-84" data-mp="3ij70yz05hfin">
          Everything Included in <span className="text-[#0A7D79]" data-id="element-85" data-mp="3mlttz38k56hf">Nursing Instructor Atlas</span>
        </h2>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" data-id="element-86" data-mp="xtpy8bnqwv03">
          {featured.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-[#0B2545] border-b-4 border-[#0A7D79] rounded-2xl p-5 flex flex-col items-start gap-3" data-id="element-87" data-mp="11t8ntkqihu99">
              <Icon size={28} className="text-white" aria-hidden="true" data-id="element-88" data-mp="1dag82nwi1dhn" />
              <span className="text-white font-extrabold text-sm md:text-base uppercase leading-snug" data-id="element-89" data-mp="18bmsmpxnjceu">
                {label}
              </span>
            </li>)}
        </ul>

        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-20" data-id="element-90" data-mp="14cdy3iusfai8">
          {supporting.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3" data-id="element-91" data-mp="uj6ykemqaoq2">
              <span className="w-9 h-9 rounded-lg bg-[#0B2545] text-white flex items-center justify-center shrink-0" data-id="element-92" data-mp="pism8ke3gsm8">
                <Icon size={18} aria-hidden="true" data-id="element-93" data-mp="gk7954re65su" />
              </span>
              <span className="text-[#0B2545] font-bold text-xs uppercase leading-tight" data-id="element-94" data-mp="gm9xlkcwbqvg">{label}</span>
            </li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-[#0B2545] rounded-3xl p-8 md:p-12 shadow-xl shadow-[#0B2545]/10 text-center" data-id="element-95" data-mp="1xiaf54yrwni">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-8" loading="lazy" data-id="element-96" data-mp="3t65m0tdek5hv" />
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-[#0B2545] mb-1" data-id="element-97" data-mp="pm1awyhrv551">
            NURSING INSTRUCTOR <span className="text-[#0A7D79]" data-id="element-98" data-mp="ay6fvbgakoos">ATLAS</span>
          </p>
          <p className="text-base font-semibold text-[#025B57] mb-3" data-id="element-99" data-mp="fwhqvpibp58l">
            The Complete 6-IN-1 Visual Nursing Education &amp; Clinical Training System for Nursing Instructors, Clinical Faculty &amp; Nurse Educators
          </p>
          <p className="text-base text-slate-700/80 max-w-2xl mx-auto mb-8" data-id="element-100" data-mp="18fx0jvsi1hqg">
            A complete visual training system created to help nursing instructors plan, explain, demonstrate
            and assess every core clinical skill with more clarity, structure and confidence.
          </p>
          <p className="text-sm font-bold tracking-widest text-[#0B2545] mb-1" data-id="element-101" data-mp="31vrq1bqpru9m">YOUR PRICE:</p>
          <p className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#0A7D79] mb-6" data-id="element-102" data-mp="2xvr8hi8bj2yc">
            {PRICE_LABEL}
          </p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-103" data-mp="256jzfpb8muyu">
            {PRIMARY_CTA}
          </Button>
          <p className="text-xs text-slate-500 mb-10" data-id="element-104" data-mp="2e6gss48koi08">
            Immediate Access · 6 Visual Volumes · 5 Bonuses · One-Time Payment
          </p>
          <div className="pt-8 border-t border-slate-200" data-id="element-105" data-mp="3ujdqib4nais9">
            <p className="text-2xl md:text-3xl font-bold tracking-tight text-[#0B2545] mb-2 uppercase" data-id="element-106" data-mp="3pmx0fbdvxucj">
              Stop Planning Every Nursing Session From Scratch.
            </p>
            <p className="text-lg font-semibold text-[#025B57]" data-id="element-107" data-mp="tpr7lj5be97h">OPEN IT. CHOOSE IT. SHOW IT. TEACH IT.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}